/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author Malinda
 * 11/27/2019
 *
 */

import React from 'react';
import warningSvg from '../../../assets/svg/warning-sm-18.svg';
import removeSvg from '../../../assets/svg/remove-sm-24.svg';
import successSvg from '../../../assets/svg/check-lg-18.svg';
import backSvg from '../../../assets/svg/chevron-back-sm-18.svg'
import nextSvg from '../../../assets/svg/chevron-next-sm-18.svg'
import elipseSvg from '../../../assets/svg/ellipsis-18.svg'
import forwardSvg from '../../../assets/svg/chevron-next-18.svg'
import downloadSvg from '../../../assets/svg/download-18.svg'
import dropdownSvg from '../../../assets/svg/dropdown-open-18.svg';
import unAuthorized from '../../../assets/svg/unauthorized-person.svg';
import error from '../../../assets/svg/browser.svg';

import './icon.css';



const Icon = (props) => {
    const iconSelectHandler = () =>{
        switch (props.name) {
            case "remove-sm-24": return removeSvg;
            case "warning-18": return warningSvg;
            case "success-18": return successSvg;
            case "back-18": return backSvg;
            case "next-18": return nextSvg;
            case "elipse-18": return elipseSvg;
            case "download-18": return downloadSvg;
            case "dropdown-open-18": return dropdownSvg;
            case "forward-18" : return forwardSvg;
            case "401": return unAuthorized;
            case "error": return error;
            default : return removeSvg;
        }
    };
    return (
        <img alt="icon in the model" className="pe-icon-18" src={iconSelectHandler()} />
    );
};

export default Icon;
